import PageFooter from "./page-footer";
import PageHeader from "./page-header";
import { Button } from "./button";

interface ConfirmModalContentProps {
    title: string;
    message: React.ReactNode;
    actionText: string;
    onAction: () => void;
    showCancel?: boolean;
    onCancel: () => void;
}

const ConfirmModalContent: React.FC<ConfirmModalContentProps> = ({
    title,
    message,
    actionText,
    onAction,
    showCancel = true,
    onCancel
}) => (
    <div className="bg-white w-screen h-screen flex flex-col overflow-auto md:h-auto md:overflow-visible md:w-[532px] md:rounded-2xl md:shadow-lg">
        {/* Header (mobile only) */}
        <PageHeader className="md:hidden" />

        {/* Content */}
        <div className="pt-6 px-4 pb-8 md:p-6 flex flex-col gap-4">
            <h2
                id="modal-title"
                className="text-lg leading-6 md:text-xl md:leading-6 font-medium text-neutral-950 tracking-[0.18px] md:tracking-[0.2px]"
            >
                {title}
            </h2>
            <p className="text-sm leading-5 md:text-base md:leading-6 text-neutral-700 tracking-[0.14px] md:tracking-[0.16px]">
                {message}
            </p>
        </div>

        {/* Actions */}
        <div className="px-4 pb-8 md:p-6 md:pt-0 flex gap-4">
            {showCancel && (
                <Button variant="tertiary" size="md" onClick={onCancel}>
                    Cancel
                </Button>
            )}
            <Button variant="primary" size="md" onClick={onAction} className="ml-auto">
                {actionText}
            </Button>
        </div>

        {/* Footer (mobile only) */}
        <PageFooter className="mt-auto md:hidden" />
    </div>
);

export default ConfirmModalContent;
